<template>
<div class="cart">
  <ul>
    <li v-for="(item, ii) in cartItems">
      <template v-if="item.type=='discount'">
        Discount <span class="price">$ {{ (item.price*1 || 0).toFixed(2) }}</span>
      </template>
      <template v-else>
<!--         <span class="subtitle">{{ item.video?item.video.subtitle:" " }}</span> -->
        <span v-if="item.type=='membership'" class="title">Membership</span>
        <span v-else class="title">{{ item.video?item.video.title:item.group.title }}</span>
        <span v-if="item.type=='membership'" class="price">$ 129.00</span>
        <span v-else class="price">{{ formatPrice(item.price[0], item.price[1]) }}</span>
        <span class="duration" v-if="item.duration">{{ item.duration }} days</span>
      </template>
    </li>
  </ul>
  <div class="total" v-if="cartItems && cartItems.length">
    <span class="total-price">$ {{ totalPrice }}</span>
    <span class="label">IN TOTAL</span>
  </div>
</div>
</template>

<script>
import Cookies from 'js-cookie';
import formatters from './formatters';
export default {
  mixins: [formatters],
  data: ()=>({
    cartItems: [],
    agreeTc: false,
    discount: "",
    discountApplied: null,
  }),
  computed: {
    loggedIn() {
      return appRoot.loggedIn;
    },
    hasPayPal() {
      return appData.hasPayPal;
    },
    totalPrice() {
      return this.cartItems.map((a)=>a.type=='discount'?a.price:a.type=='membership'?149:this.formatPriceRaw(a.price[0], a.price[1])).reduce((a,b)=>a*1+b*1, 0).toFixed(2);
    },
  },
  methods: {
    async updateCartItems() {
      var currentUser=appRoot.loggedIn || {};
      var allPayments=currentUser.allPayments || [];
      var cart=[];
      try {
        cart=(Cookies.get("appcart") || "").split(",").filter((a)=>a);
      } catch(e) { } 
      var cartItemsAwait=[];
      for(var item of cart) {
        var variant=item.split("-")[1] || null;
        item=item.split("-")[0];
        if (item[0]=="c")
          cartItemsAwait.push([item, api.get('Video', variant), variant]);
        else if (item[0]=="m")
          cartItemsAwait.push([item, {item: {}}, variant]);
        else
          cartItemsAwait.push([item, api.get(item[0]=="g"?"VideoGroup":"Video", item.substring(1)), variant]);
      }
      this.discountApplied=null;
      var cartItems2=[];
      for(var item of cartItemsAwait) {
        var xitem=[item[0], (await item[1]).item, item[2]];
        cartItems2.push(xitem);
        if (item[0]=="c")
          this.discountApplied=xitem[1];
      }
      var cartItems=[];
      for(var item of cartItems2) {
        if (item[0][0]=="c") {
          cartItems.push({
            discount: item[1],
            group: null,
            video: null,
            type: "discount",
            price: 0,
          });
        } else if (item[0][0]=="m") {
          cartItems.push({
            video: null,
            group: null,
            duration: 365,
            price: 129,
            type: "membership",
          });
        } else if (item[0][0]=="g") {
          var duration=([30, 90, 180, 365])[item[2]];
          var field=(["priceUsd", "renewPriceUsd", "renewPrice2Usd", "renewPrice3Usd"])[item[2]];
          var price=[item[1], field];
            
          cartItems.push({
            video: null,
            group: item[1],
            duration,
            price,
          });
        } else {
          var duration=([1, 3, 7, 30, 90])[item[2]];
          var field=(["priceUsd","price1","price2","price3","price4"])[item[2]];
          var price=[item[1], field];
          
          cartItems.push({
            video: item[1],
            group: item[1].group,
            duration,
            price,
          });          
        }
      }
      if (false) {
      var cartItems2=cartItems.filter((a)=>a.type!="discount");
      var discount=cartItems.find((a)=>a.type=="discount");
      if (discount && discount.onlyFirst) {
        if (cartItems2[0]) {
          var fiPrice=this.formatPriceRaw(cartItems2[0].price[0], cartItems2[0].price[1]);
          discount.price=Math.min(0, -1*(fiPrice/100*discount.percent+(discount.amount || 0)*1));
        }
        cartItems2.splice(1, 0, discount);
      } else if (discount) {
        discount.price=0;
        for(var cartItem of cartItems2) {
          var fiPrice=this.formatPriceRaw(cartItem.price[0], cartItem.price[1]);
//           console.log(fiPrice, discount);
          discount.price+=Math.min(0, -1*(fiPrice/100*discount.percent+(discount.amount || 0)*1));
        }
        cartItems2.push(discount);
      }
      
      this.cartItems=cartItems2;
      } else {
        var discount=cartItems.find((a)=>a.type=="discount");
        if (discount) {
          var item=cartItems.find(a=>a.video && a.video.id==discount.discount.id);
          discount.price=-0.01*this.formatPriceRaw(item.price[0], item.price[1])*item.video.discountpercent;
        }
        this.cartItems=cartItems;
      }
    },

  },
  mounted() {
    this.updateCartItems();
  },
}

</script>
